import * as React from "react";
import { TextField } from "react-admin";
import { subResourceList } from "../_subresource";
import { FrDateField } from "../../components/FrDateField";

// GET /events/{eventId}/comments (lecture seule : pas d'endpoint d'édition).
export default {
  list: subResourceList({
    parentParam: "eventId",
    parentLabel: "ID événement",
    children: [
      <TextField key="content" source="content" label="Commentaire" />,
      <TextField key="authorName" source="authorName" label="Auteur" />,
      <TextField key="authorId" source="authorId" label="ID auteur" />,
      <FrDateField key="createdAt" source="createdAt" label="Date" showTime />,
    ],
  }),
};
